const AppTheme = {
  default: {
    darkBackground: "rgb(40, 44, 52)",
    midBackground: "rgb(51, 56, 66)",
    lightBackground: "rgb(51, 56, 66)",
    highlight: "rgb(255, 69, 0)",
    heading: "rgb(66, 165, 245)",
    grey: "rgb(171,178,191)",
  },
  atom_one_dark: {
    darkBackground: "rgb(33,37,43)",
    midBackground: "rgb(40,44,52)",
    lightBackground: "rgb(51,56,66)",
    // highlight: "rgb(249,130,108)",
    highlight: "rgb(66, 165, 245)",
    heading: "rgb(66, 165, 245)",
    grey: "rgb(171,178,191)",
  },
  github_dark: {
    darkBackground: "rgb(31,36,40)",
    midBackground: "rgb(36,41,46)",
    lightBackground: "rgb(36,41,46)",
    highlight: "rgb(255, 69, 0)",
    heading: "rgb(66, 165, 245)",
    grey: "rgb(171,178,191)",
  },
  community_material: {
    darkBackground: "rgb(25,34,39)",
    midBackground: "rgb(38,50,56)",
    lightBackground: "rgb(38,50,56)",
    highlight: "rgb(128,203,196)",
    heading: "rgb(66, 165, 245)",
    grey: "rgb(171,178,191)",
  },
  vscode_dark: {
    darkBackground: "rgb(30,30,30)",
    midBackground: "rgb(45,45,45)",
    lightBackground: "rgb(60,60,60)",
    highlight: "rgb(82,139,255)",
    heading: "rgb(66, 165, 245)",
    grey: "rgb(171,178,191)",
  },
};
export default AppTheme;
